import React from "react";
import OrderCalenderIcon from "assets/images/Shopping_basket.svg";
import OrderTableMobile from "../OrderTableMobile";

interface Props {
  data?: any[];
  onDownload?: (val: any) => void;
}

const OrdersMobileTab = ({ data, onDownload }: Props) => {
  return (
    <div className="order-wrapper-mobile">
      <div className="PersonalInformation-otr" style={{ marginTop: 16, marginBottom: 30 }}>
        <div className="PersonalInfo-icon-otr">
          <img className="PersonalInfo-icon" src={OrderCalenderIcon} alt="icon" />
        </div>
        <h3 className="PersonalInfo-heading">פרטי המנוי</h3>
      </div>
      <OrderTableMobile data={data} onDownload={onDownload} />
    </div>
  );
};

export default OrdersMobileTab;
